import { HighchartsChart } from 'components/HighchartsChart/HighchartsChart'
import type { HighchartsOptionsWithSemiosAdditions } from 'components/StackedChart/types'
import { memo, useMemo } from 'react'
import { buildIcsChartOptions } from './_utils/icsChartOptions'

const IcsChartBase = ({
  chart: chartOptionsProp,
  chartVisible,
  timezone,
}: {
  chart: HighchartsOptionsWithSemiosAdditions
  chartVisible: boolean
  timezone: string
}) => {
  const chartOptions = useMemo(() => {
    return buildIcsChartOptions({
      chartOptions: chartOptionsProp,
      timezone,
    })
  }, [chartOptionsProp, timezone])

  const chartStyles = useMemo(
    () => ({
      height: chartVisible ? Number(chartOptions?.chart?.height) || 300 : 0,
      overflow: 'hidden',
      width: '100%',
    }),
    [chartVisible, chartOptions?.chart?.height],
  )

  if (!chartVisible) {
    return <div css={chartStyles} />
  }

  return (
    <div css={chartStyles}>
      <HighchartsChart id={chartOptions.semiosHighchartsAdditions.id} chartOptions={chartOptions} />
    </div>
  )
}

export const IcsChart = memo(IcsChartBase)
